module.exports = __webpack_public_path__ + "static/media/Logo_Dark.661cba92.svg";